import { Controller } from "@hotwired/stimulus"

const OPEN_CLASS = "catalog-filters-open"

export default class extends Controller {
  open() {
    document.body.classList.add(OPEN_CLASS)
  }

  close() {
    document.body.classList.remove(OPEN_CLASS)
  }
}
